import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import App from './App';
import SubscriptionPlansPage from './components/Subscriptions/Plans';
import SubscriptionSuccess from './components/Subscriptions/SubscriptionSuccess';
import SubscriptionCancelled from './components/Subscriptions/SubscriptionCancelled';

// Suppress ResizeObserver errors (they are benign and don't affect functionality)
const resizeObserverErrorHandler = (e: ErrorEvent) => {
  if (
    e.message === 'ResizeObserver loop completed with undelivered notifications.' ||
    e.message === 'ResizeObserver loop limit exceeded'
  ) {
    e.stopImmediatePropagation();
    return;
  }
};

window.addEventListener('error', resizeObserverErrorHandler);

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
    <BrowserRouter>
      <Routes>
        <Route path="/subscription-plans" element={<SubscriptionPlansPage />} />
        <Route path="/subscription-plans/success" element={<SubscriptionSuccess />} />
        <Route path="/subscription-plans/cancelled" element={<SubscriptionCancelled />} />
        <Route path="/admin/*" element={<App />} />
      </Routes>
    </BrowserRouter>
  </React.StrictMode>
);
